import { availableFonts, FONTS, type FontId } from '@abgen/model';

/** Basis-URL, unter der die Schriftdateien liegen (siehe vite.config.ts). */
export const FONT_BASE_URL = '/fonts';

/**
 * Erzeugt die `@font-face`-Regeln für alle Schriften, deren Dateien vorliegen.
 * Variable Schriften erhalten die Gewichtsspanne 100–900.
 */
export function fontFaceCss(base: string = FONT_BASE_URL): string {
  const rules: string[] = [];
  for (const { id, entry } of availableFonts()) {
    for (const file of entry.files) {
      if (file.style === 'guides') continue; // eigene Familie, s. guidesFamily()
      const url = `${base}/${id}/${encodeURIComponent(file.woff2)}`;
      rules.push(
        [
          '@font-face {',
          `  font-family: '${entry.cssFamily}';`,
          `  src: url('${url}') format('woff2');`,
          `  font-weight: ${file.style === 'variable' ? '100 900' : (file.weight ?? 400)};`,
          `  font-style: ${file.italic ? 'italic' : 'normal'};`,
          '  font-display: block;',
          '}',
        ].join('\n'),
      );
    }
    const guides = entry.files.find((file) => file.style === 'guides');
    if (guides) {
      rules.push(
        [
          '@font-face {',
          `  font-family: '${guidesFamily(id)}';`,
          `  src: url('${base}/${id}/${encodeURIComponent(guides.woff2)}') format('woff2');`,
          '  font-weight: 400;',
          '  font-style: normal;',
          '  font-display: block;',
          '}',
        ].join('\n'),
      );
    }
  }
  return rules.join('\n\n');
}

/** Familienname der Lineatur-Variante einer Ausgangsschrift. */
export function guidesFamily(id: FontId): string {
  return `${FONTS[id].cssFamily} Guides`;
}

/** CSS-Stapel für ein Dokument-Schriftfeld. */
export function cssFontStack(id: FontId): string {
  return `'${FONTS[id].cssFamily}', 'Andika', sans-serif`;
}

let installed = false;

/** Hängt die Schriftregeln einmalig in den Dokumentkopf. */
export function installFontFaces(doc: Document = document): void {
  if (installed && doc === document) return;
  const style = doc.createElement('style');
  style.dataset.abgen = 'font-faces';
  style.textContent = fontFaceCss();
  doc.head.append(style);
  installed = true;
}
